import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const alertsValidation = yup.object().shape({
    resource: yup.string().required(ERRORS.required),
    threshold: yup.string().required(ERRORS.required),
    notificationType: yup.mixed().required(ERRORS.required),
});
